import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../../styled/constants';
import { StyledSpaceSection } from '../../../SpaceSection/styled';

export const PriceSizeBlockWrapper = styled(StyledSpaceSection)<{
  $withoutBorder: boolean;
}>`
  ${({ $withoutBorder }) =>
    !$withoutBorder &&
    css`
      @media (min-width: ${Breakpoints.smallDesktop}px) {
        padding-bottom: 20px;
        border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
      }
    `}
`;
